<template>
  <div class="identity-certification">
        <h2>实名认证</h2>
        <p class="mb-4">请上传本人有效身份证正反面，确保图片清晰、完整、无遮挡。</p>
        <ul class="steps">
            <li :class="{'steps-active':activeStep>=1}"><p>1</p>上传身份证</li>
            <li :class="{'steps-active':activeStep>=2}"><p>2</p>信息审核</li>
            <li :class="{'steps-active':activeStep>=3}"><p>3</p>审核结果</li>
        </ul>
        <!--提交认证-->
        <template v-if="activeStep === 1">
            <el-form :inline="true" :model="formData" :rules="rules" ref="formData" class="full-form" :hide-required-asterisk="true" label-width="80px">
                <el-form-item prop="truename" label="真实姓名" style="width: 115%;">
                    <el-input v-model.trim="formData.truename"
                        type="text"
                        placeholder="请输入您的真实姓名"
                        clearable
                    />
                </el-form-item>
                <el-form-item prop="card" label="身份证号" style="width: 115%;">
                    <el-input v-model.trim="formData.card"
                        type="text"
                        placeholder="请输入您的身份证号"
                        clearable
                    />
                </el-form-item>
                <div class="identity">
                    <div class="identity-item">
                        <img src="/images/public/identity_1.jpg">
                        <p><i class="el-icon-upload2"></i></p>
                        <h2>上传身份证正面</h2>
                        <upload-image  @fileChange="(imgs)=>{this.formData.card_a = imgs[0]||'';}"  :maxLength="1" editMode class="upload-image" :identityMode="true" />
                    </div>
                    <div class="identity-item">
                        <img src="/images/public/identity_2.jpg">
                        <p><i class="el-icon-upload2"></i></p>
                        <h2>上传身份证背面</h2>
                        <upload-image  @fileChange="(imgs)=>{this.formData.card_b = imgs[0]||'';}"  :maxLength="1" editMode class="upload-image" :identityMode="true" />
                    </div>
                </div>
                <el-button type="primary" @click="submit" style="width: 100%; margin-top: 50px; width: 100%;" :loading="loading">提交认证</el-button>
            </el-form>
        </template>
        <!--认证审核中-->
        <template v-if="activeStep === 2">
            <div class="verify-result">
                <img src="/images/public/identity_3.jpg" class="verify-img">
                <div class="verify-text">
                    <h2>您的身份证正在审核中</h2>
                    <p>我们已收到您的身份证信息，正在进行人工审核</p>
                    <p>请耐心等待，通常需要1-3个工作日</p>
                </div>
            </div>
        </template>
        <template v-if="activeStep === 3">
            <div class="verify-result">
                <img src="/images/public/identity_4.jpg" class="verify-img">
                <div class="verify-text">
                    <h2>身份认证成功</h2>
                    <p>您的身份证信息已通过审核，感谢您的配合！</p>
                </div>
                <div class="verify-info">
                    <ul>
                        <li>
                            <i class="icon-shenfenzhengshixin iconfont"></i>
                            <p>认证姓名：</p>
                            <span>{{formData.truename}}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </template>
  </div>
</template>

<script>
import { mapState,mapActions } from 'vuex'
import { UploadImages } from '@/assets/utils/uploadFiles'
import numeral from 'numeral';
export default {
  name: 'IdentityCertification',
  components: {},
  props: {},
  data() {
    return {
        activeStep:-1,        //当前步骤
        is_real:-1,     //是否已认证身份
        formData: {
            truename:'',
            card:'',
            card_a:'',
            card_b:'',
        },
        loading:false,
        rules:{
          truename:{ required: true, message: '请填写姓名'},
          card:{ 
                validator: this.validateIdCard,
                trigger: 'blur'
          },
        },
    };
  },
  computed: {
    ...mapState(['userLoginMessage','newMessageInform'])
  },
  watch: {
    //接收到消息更新列表
    newMessageInform (newVal) {
        if(newVal.type==63){
            this.getVerifyList();
        }
    },
  },
  created() {},
  mounted() {
    this.is_real = this.userLoginMessage.is_real;
    //如果未认证身份，获取认证列表
    this.getVerifyList();
  },
  methods: {
    ...mapActions(['POST_RealVerifySubmit','POST_RealVerifyList']),
    //获取认证列表
    async getVerifyList() {
        await this.POST_RealVerifyList({
            data:{
                page:1,
                num:10,
            },
            successFun: (res) =>{
                if(res.count>0&&res.list[0].status==1){
                    //已认证身份
                    this.activeStep=2;
                }else if(res.count>0&&res.list[0].status==3){
                    //已认证身份
                    this.activeStep=3;
                    this.formData=res.list[0];
                }else{
                    //未认证身份
                    this.activeStep=1;
                }
            }
        });
    },
    //提交身份认证
    submit() {
        this.$refs.formData.validate(async valid => {
            if (!valid) return;
            if(!this.formData.card_a||!this.formData.card_b){
                this.$message.error('请上传身份证正反面');
                return;
            }
            let formData = this.formData;
            this._confirm('确认提交身份认证么？',async () => {
                this.loading = true;
                formData.card_a = await UploadImages(formData.card_a);
                formData.card_b = await UploadImages(formData.card_b);
                formData.card_a = formData.card_a[0];
                formData.card_b = formData.card_b[0];
                this.POST_RealVerifySubmit({
                    data:formData,
                    successFun: () =>{
                        this.activeStep=2;
                        //提交成功
                    }
                });
            })
        });

    },
    // 身份证校验函数 GB11643 国标
    validateIdCard(rule, value, callback) {
        if (!value) {
        return callback(new Error('请输入身份证号码'))
        }
        value = value.trim()
        // 18位正则基础校验
        const reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))((0[1-9])|([12]\d)|(3[01]))\d{3}[\dXx]$/
        if (!reg.test(value)) {
        return callback(new Error('请输入正确的身份证号'))
        }
        // 加权系数
        const weight = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
        const checkCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
        let sum = 0
        for (let i = 0; i < 17; i++) {
        sum += Number(value[i]) * weight[i]
        }
        const mod = sum % 11
        const lastChar = value[17].toUpperCase()
        if (lastChar !== checkCode[mod]) {
            return callback(new Error('请输入正确的身份证号'))
        }
        callback()
    },
  }
};
</script>

<style lang="scss" scoped>
    .identity-certification{
        text-align: left;
        margin:20px auto;
        width: 1200px;

    }
    .identity-certification .mb-4{
        margin-top:6px;
        color: #999;

    }
    .identity{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .identity-item{
        width: 46%;
        background: #f7fbfe;
        height: 300px;
        border: 1px dashed #d1dffa;
        border-radius: 4px;
        text-align: center;
        overflow: hidden;
        cursor: pointer;
        position: relative;
        >img{
            width: 45%;
            margin-top: 20px;
        }
        p{
            background: var(--smtc-color-primary);
            width: 50px;
            height: 50px;
            line-height: 50px;
            border-radius: 50px;
            margin: 10px auto;
            color: #fff;
            font-size: 30px;
            
        }
        h2{
            margin-top: 18px;
        }
    }
    .upload-image{
        position: absolute;
        width: 600px;
        height: 100%;
        top: 0;
        left: 0;
    }
    //步骤条
    .steps{
        display: flex;
        justify-content: space-between;
        margin: 20px auto;
        border-bottom: 1px dashed #d1dffa;
        padding-bottom: 20px;
        li{
            display: flex;
            position: relative;
            &::after{
                content: '';
                position: absolute;
                top: 10px;
                left: 120px;
                width: 400%;
                height: 1px;
                background: #d1dffa;
            }
        }
        li:nth-child(2){
            &::after{
                width: 450%;
            }
        }
        li:nth-child(3){
            &::after{
                display: none;
            }
        }
        p{
            width: 20px;
            height: 20px;
            line-height: 20px;
            border-radius: 50%;
            text-align: center;
            border: 1px solid #d1dffa;
            font-size: 12px;
            margin-right: 10px;
        }
    }
    .steps-active{
        p{
            background: var(--smtc-color-primary);
            color: #fff;
        }
    }
    .verify-result{
        background-color: #f5f9fd;
        height: 500px;
        width: 100%;
        border-radius: 4px;
        overflow: hidden;
    }
    .verify-img{
        width: 26%;
        margin: 30px auto;
        display: block;
    }
    .verify-text{
        text-align: center;
        p{
            color: #858ea4;
            margin-top:6px;
        }
    }
    .verify-info{
        width: 60%;
        margin: 0 auto;
        li{
            display: flex;
            justify-content:center;
            color: #858ea4;
            width: 40%;
            padding: 10px 0;
            border-radius: 4px;
            background-color: #fff;
            margin: 0 auto;
            margin-top: 20px;
            i{
                margin-right: 8px;
                margin-top: 1px;
                color:var(--smtc-color-primary);
                font-size: 18px;
            }
        }
    }
</style>
